import { z } from "zod";

export const generateGnreSchema = z.object({
  fromDate: z.string().min(1, "Data inicial é obrigatória"),
  toDate: z.string().min(1, "Data final é obrigatória"),
  paymentDate: z
    .string()
    .min(1, "Data de pagamento é obrigatória")
    .refine((date) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const [year, month, day] = date.split("-").map(Number);
      const payment = new Date(year, month - 1, day);
      const currentMonth = today.getMonth();
      const currentYear = today.getFullYear();
      return (
        payment >= today &&
        payment.getMonth() === currentMonth &&
        payment.getFullYear() === currentYear
      );
    }, "Data de pagamento deve ser neste mês a partir de hoje"),
});

export type GenerateGnreFormData = z.infer<typeof generateGnreSchema>;
